import { configureStore, combineReducers } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import fileReducer from "./slices/fileSlice";
import { persistReducer, persistStore } from "redux-persist";
import storage from "redux-persist/lib/storage";
import storageSession from "redux-persist/lib/storage/session";

const rootReducer = combineReducers({
  auth: authReducer,
  file: fileReducer,
});

// Persist configs
const authPersistConfig = {
  key: "auth",
  storage: storageSession,
  whitelist: ["isLoggedIn", "user", "accessToken", "refreshToken", "tokenExpiry", "maxUploadFileSize", "subscription"],
};

const filePersistConfig = {
  key: "file",
  storage,
  whitelist: [
    "files",
    "uploadedFilePath",
    "localFileMeta",
    "lastResponse",
    "activeStep",
    "totalSteps",
    "processResponse",
    "applyResponse",
    "generativeEngineInsightsResult",
  ],
};

const persistedReducer = combineReducers({
  auth: persistReducer(authPersistConfig, authReducer),
  file: persistReducer(filePersistConfig, fileReducer),
});

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          "persist/PERSIST",
          "persist/REHYDRATE",
          "persist/FLUSH",
          "persist/PAUSE",
          "persist/PURGE",
          "persist/REGISTER",
        ],
      },
    }),
});

export const persistor = persistStore(store);

export default store;
